import { qoursesApiInstructor } from '@/api/qourses-instructor.tsx'
import { useQuery } from '@tanstack/react-query'
import { InstructorEntity } from '../../../qourses-api-client'

export default function useGetCustomerInstructor(): {
  instructor: InstructorEntity
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: instructor,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(['instructor', 'customer'], async () => {
    return qoursesApiInstructor.profileCustomer.profileCustomerControllerGetInstructorV1()
  })

  return { instructor, isLoading, isError, refetch, isRefetching }
}
